import $ from 'jquery';

import Draggable from './draggable';

/**
 * Lazy to create a element using document.createElement
 *
 * @param {string} name the name of the element to create
 *
 * @returns {HTMLElement} the element created
 */
const mel = (name) => document.createElement(name);

const DATA_PROP_PREFIX = "data-ca-ic-option-";

export default class ImageCompare {
    /**
     * The class creates an image compare slider
     *
     * @param {$|HTMLElement} element The element to create the umage slider from
     * @param {{}} options The options used to configure the class
     *      @prop {string} container_class The CSS Class to give to the main container
     *      @prop {string} image_class The CSS Class to use for the ImageCompare image component
     *      @prop {string} drag_class The CSS Class to use for the draggable area
     *      @prop {string} handle_class The CSS Class to use for the drag handle
     *      @prop {string} image_image_class The CSS Class to give the image partial of the ImageCompare image component
     *      @prop {Boolean} hover_interaction = False This hides the controls until the user hovers on teh ImageCompare component , allows the user to see the differences better
     *      @prop {string} hover_interaction_class The CSS class that has the styles to hide/show the controls on hover
     *      @prop {string} interaction_message_class The CSS clss for the message to inform the user they need to hover to show the controls.
     *      @prop {string} interaction_message The message that is show to inform the user they need to hover to interact
     *      @prop {Boolean} allow_override When true this allows the plugin to be also configured using data attributes on the main element
     */
    constructor(element, options) {

        this.element = $(element);
        this.options = $.extend({
            container_class                 : "ca-ic-container",
            image_class                     : "ca-ic-image",
            drag_class                      : "ca-ic-dragarea",
            handle_class                    : "ca-ic-handle",
            image_image_class               : "ca-ic-image-image",
            hover_interaction               : false,
            hover_interaction_class         : "ca-ic-hover-interaction",
            interaction_message_class       : "ca-ic-interaction-message",
            interaction_message             : "Hover to interact",
            allow_override                  : false
        }, options);

        if(this.options.allow_override) {
            this.attrConfigure();
        }

        this._images = [];

        this.uplift();
    }

    /**
     * Allows you to set the options using Data Attributes on the main element
     */
    attrConfigure() {
        Object.keys(this.options).forEach((key) => {
            const attr = this.element.attr(`${DATA_PROP_PREFIX}${key}`);
            let use;
            if(attr || false) {
                switch(attr) {
                    case "true":
                        use = true;
                        break;
                    case "false":
                        use = false;
                        break;
                    default:
                        use = attr;
                }
                this.options[key] = use;
            }
        });
    }

    /**
     * Uplifts the element passed into a full blown image compare slider
     */
    uplift() {
        this.images();
        this.empty();

        const container = this.attachImages();

        if(this.options.hover_interaction) {
            container.append(this.hoverInteractionMessage());
        }

        this.element.append(container);

        this.sizeUp();
        this.addEvents();
    }

    /**
     * Sets the dimensions of the image compare component and its children
     */
    sizeUp() {
        this.setContainerSize();
        this.setImageSize();
    }

    /**
     * Finds all the images in the element passed and returns them as a std array
     *
     * @return {Array} returns the array of images found.
     *
     * @todo Updaete entire class to support more than 2 image comparison.
     */
    images() {
        if ( !this._images.length ) {
            const images = $('img', this.element);

            if(images.length < 2 ) {
                throw new Error("Two images are needed to compare");
            }

            let _this = this;

            images.each(function() {
                _this._images.push($(this));
            });
        }

        return this._images
    }

    /**
     *  Appends the images,  as ImageCompare image components
     *
     * @returns {$} The jQuery object referencing the component
     *
     * @todo is this neat, could it be neater, should it perform the append?
     */
    attachImages() {
        const container = this.container();

        // Making draggable area that moves to the right of the left image
        container.append($(mel('div')).addClass('ca-ic-wider-draggable-area').append(this.dragHandle()));

        let first = true;
        this.images().forEach((el, i) => {
            container.append(this.image($(el), first)
                .addClass(`ca-ic-layer-${(i+1)}`)
            );
            first = false;
        });

        return container;
    }

    /**
     * Clears all teh elements out the passed element ready to append our components
     */
    empty() {
        this.element.empty();
    }

    /**
     * Adds the events listenner to component
     */
    addEvents() {
        this.addDragEvent();
        this.addResizeEvent();
    }

    /**
     * Makes the drag handle and drag area draggable and attaches events in order to handle that.
     */
    addDragEvent() {
        const draggable = new Draggable($('[data-ca-drag-area="true"]', this.container()));

        // Can not use Fat Arrow (=>) here because jQuery scopes `this` to the element affected
        // That is information that we need!
        // We therefore also have to capture an instance to this class (as `_this`)

        const _this = this;

        draggable.on("dragging", function(e, session, moved) {
            const acton = $(this).parent();
            const width = (acton.width() - moved.left);
            const containerWidth = _this.container().width();
            const widthPercent = ((width / containerWidth) * 100);

            // console.group("Drag data");
            // console.log("Container Width", containerWidth);
            // console.log("Element Offset", _this.element.offset().left)
            // console.log("Session", session);
            // console.log("Moved", moved);
            // console.log("Acton Width", acton.width(), acton.outerWidth());
            // console.log("This Width / Offset", $(this).width(), $(this).outerWidth(), $(this).offset());
            // console.log("Calculate Width / %", width, widthPercent);
            // console.groupEnd();

            if ( width >= 0 && width <= containerWidth) {
                acton.width(`${widthPercent}%`);
            }

        });
    }

    /**
     * Listens to when the window is resized and resizes the ImageCompare Component
     */
    addResizeEvent() {
        $(window).resize(() => this.sizeUp());
    }

    /**
     * Returns the container , if it can't find a container in the element passed it creates it first
     *
     * @return {$} The jQuery object for the container component.
     */
    container() {
        let container = $("[data-ca-ic-container]" , this.element);
        if ( !container.length ) {
            container = $(mel('div'))
                    .attr("data-ca-draggable", "draggable")
                    .addClass(this.options.container_class)
                    .attr("data-ca-ic-container", "true");

            if (this.options.hover_interaction || false ) {
                container.addClass(this.options.hover_interaction_class);
            }
        }
        return container;
    }

    /**
     * Creates the Hover to Interact message
     *
     * @return {$} The Hover to Interact component
     */
    hoverInteractionMessage() {
        const messageContainer = $(mel('div'))
                                    .addClass(this.options.interaction_message_class);

        const message = $(mel('span'))
                            .text(this.options.interaction_message);


        return messageContainer.append(message);
    }

    /**
     * Creates the ImageCompare image component
     *
     * @param {$} img The jQuery object for the standard html image
     * @param {Boolean} isSlidable Tells the compenent to add the handle for dragging
     *
     * @return {$} The ImageCompare image component
     */
    image(img, isSlidable = false) {
        const imageContainer = $(mel('div'))
                        .addClass(this.options.image_class);

        if(isSlidable) {
            imageContainer.append(this.dragHandle());
        }

        const image = $(mel('div'))
                        .addClass(this.options.image_image_class)
                        .attr("data-ca-image", "true")
                        .css('background-image', `url(${img.attr('src')}`);

        imageContainer.append(image);

        return imageContainer;
    }

    /**
     * Sets the size of the ImageCompare image component to match the container.
     */
    setImageSize() {
        const {width, height} = this.calDimensions();
        $('[data-ca-image]', this.container()).width(width).height(height);
    }

    /**
     * Sets the size of the ImageCompare component container
     */
    setContainerSize() {
        const {width, height} = this.calDimensions();
        this.container().width(width).height(height);
    }

    /**
     * Creates a ImageCompare DragHandle component
     *
     * @returns {$} The ImageCompare DragHandle
     */
    dragHandle() {
        let area = $(mel('div'))
                .addClass(this.options.drag_class)
                .attr('data-ca-drag-area', 'true');

        let handle = $(mel('div'))
                .addClass(this.options.handle_class)
                .attr('data-ca-drag-handle', 'true');

        return area.append(handle);

    }

    /**
     * Calculates the dimensions of the container
     *
     * It works it out by
     *  - Get the biggest image dimension in each axis
     *  - If the biggest image dimension in ether axis is larger than that of the container in the same axis
     *    set the image dimension to the container dimension in that axis.
     *  - If the biggest image dimension in ether axis is smaller than the container in the same axis
     *    set the image dimension to the largest image dimension in that axis.
     *
     * @returns {{width: number, height: number}} the image dimensions calculated.
     */
    calDimensions() {
        const containerWidth = this.element.width();
        const biggestImageDimensions = this.biggestImageDimensions();

        let width = 0;
        let height = 0;

        if(biggestImageDimensions.width > containerWidth ) {
            width = containerWidth;
            height = +(width * biggestImageDimensions.ratio);
        } else {
            width = biggestImageDimensions.width;
            height = biggestImageDimensions.height;
        }

        return {
            width: width,
            height: height
        }
    }

    /**
     * Loops over all the images and works out the biggest dimension in each axis.
     *
     * @returns {{width: number, height: number, ratio: number}} contains the lagest axis and the aspect ratio
     */
    biggestImageDimensions() {
        let width = 0;
        let height = 0;

        this.images().forEach((el) => {
            const $el = $(el);

            // console.log($el[0].width);

            if($el[0].width > width) width = $el[0].width;
            if($el[0].height > height) height = $el[0].height;
        });

        return {
            width: +width,
            height: +height,
            ratio: (height/width)
        }
    }
}

